/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { FilesControllerGetFileRenditionDownloadUrlQueryResponse, FilesControllerGetFileRenditionDownloadUrlPathParams, FilesControllerGetFileRenditionDownloadUrlQueryParams } from "../../models/filesController/FilesControllerGetFileRenditionDownloadUrl";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { filesControllerGetFileRenditionDownloadUrl } from "../../clients/filesService/filesControllerGetFileRenditionDownloadUrl";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const filesControllerGetFileRenditionDownloadUrlQueryKey = (id: FilesControllerGetFileRenditionDownloadUrlPathParams["id"], renditionId: FilesControllerGetFileRenditionDownloadUrlPathParams["renditionId"], params: FilesControllerGetFileRenditionDownloadUrlQueryParams = {}) => [{
  url: '/api/v1/files/:id/renditions/:renditionId/download-url',
  params: {
    id: id,
    renditionId: renditionId
  }
}, ...(params ? [params] : [])] as const;
export type FilesControllerGetFileRenditionDownloadUrlQueryKey = ReturnType<typeof filesControllerGetFileRenditionDownloadUrlQueryKey>;
export function filesControllerGetFileRenditionDownloadUrlQueryOptions(id: FilesControllerGetFileRenditionDownloadUrlPathParams["id"], renditionId: FilesControllerGetFileRenditionDownloadUrlPathParams["renditionId"], params?: FilesControllerGetFileRenditionDownloadUrlQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = filesControllerGetFileRenditionDownloadUrlQueryKey(id, renditionId, params);
  return queryOptions<FilesControllerGetFileRenditionDownloadUrlQueryResponse, ResponseErrorConfig<Error>, FilesControllerGetFileRenditionDownloadUrlQueryResponse, typeof queryKey>({
    enabled: !!(id && renditionId),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return filesControllerGetFileRenditionDownloadUrl(id, renditionId, params, config);
    }
  });
}

/**
 * @description Returns a pre-signed S3 URL for downloading the file rendition.
 * @summary Get a signed download URL for a file rendition
 * {@link /api/v1/files/:id/renditions/:renditionId/download-url}
 */
export function useFilesControllerGetFileRenditionDownloadUrl<TData = FilesControllerGetFileRenditionDownloadUrlQueryResponse, TQueryData = FilesControllerGetFileRenditionDownloadUrlQueryResponse, TQueryKey extends QueryKey = FilesControllerGetFileRenditionDownloadUrlQueryKey>(id: FilesControllerGetFileRenditionDownloadUrlPathParams["id"], renditionId: FilesControllerGetFileRenditionDownloadUrlPathParams["renditionId"], params?: FilesControllerGetFileRenditionDownloadUrlQueryParams, options: {
  query?: Partial<QueryObserverOptions<FilesControllerGetFileRenditionDownloadUrlQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? filesControllerGetFileRenditionDownloadUrlQueryKey(id, renditionId, params);
  const query = useQuery({
    ...filesControllerGetFileRenditionDownloadUrlQueryOptions(id, renditionId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}